import {handleActions} from 'redux-actions';
import {Record, List, Map} from 'immutable';

import actionTypes from './action-types';
import Recipient from './model';
import Api from './api';

const RecipientsState = Record({
    fetching: Boolean(false),
    recipients: List(),
    from: List(),
    error: String(''),
});

const initialState = new Map(Object.keys(Api).map(type => [type, new RecipientsState()]));

const updateType = (state, type, updateFunction) => {
    return state.update(type, new RecipientsState(), updateFunction);
};

export default handleActions(
    {
        [actionTypes.RECIPIENTS_FETCH]: (state, {payload}) => {
            return updateType(state, payload.type, recipientState =>
                recipientState.merge({
                    fetching: true,
                    recipients: List(),
                }),
            );
        },
        [actionTypes.RECIPIENTS_FETCH_SUCCESS]: (state, {payload}) => {
            const recipients = payload.recipients.map(Recipient.fromAPI);
            return updateType(state, payload.type, recipientState =>
                recipientState.merge({
                    fetching: false,
                    recipients: List.of(...recipients),
                }),
            );
        },
        [actionTypes.RECIPIENTS_FETCH_FAILED]: (state, {payload}) =>
            updateType(state, payload.type, recipientState => recipientState.merge({error: payload.message})),
        [actionTypes.RECIPIENTS_SENDERS_FETCH]: (state, {payload}) => {
            return updateType(state, payload.type, recipientState =>
                recipientState.merge({
                    from: List(),
                }),
            );
        },
        [actionTypes.RECIPIENTS_SENDERS_FETCH_SUCCESS]: (state, {payload}) => {
            return updateType(state, payload.type, recipientState =>
                recipientState.merge({
                    from: payload.senders,
                }),
            );
        },
        [actionTypes.RECIPIENTS_SENDERS_FETCH_FAILED]: (state, {payload}) =>
            updateType(state, payload.type, recipientState => recipientState.merge({error: payload.message})),
    },
    initialState,
);
